import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoMdClose } from "react-icons/io";
import { showIconByServiceId } from "../../../helper/showIconByServiceId";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FaEye, FaPencilAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import {ability} from "../../../config/acl/ability";

const DataTable = ({ data, setData, rowsPerPage, currentPage }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const canReviewOrder = ability.can('order', 'review');
  console.log(`test can review ${canReviewOrder}`)

  // Handle sorting logic
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] === null || b[orderBy] === null) return 0; // Null-safe comparison
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  // Export PDF
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("services Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        [
          "ID",
          "Service",
          "Service Type",
          "User Name",
          "Price",
          "Panel URL",
          "Payment Method",
          "Created At",
          "Status Payment",
          "Status",
        ],
      ],
      body: sortedData.map((item) => [
        item.request_id,
        item.our_service || "N/A",
        item.our_service_type || "N/A",
        item.user_name || "N/A",
        item.price || "N/A",
        item.panel_url || "N/A",
        item.payment_method || "N/A",
        item.created_at || "N/A",
        item.status_payment || "N/A",
        item.status || "N/A",
      ]),
    });
    doc.save("ServicesTable.pdf");
  };

  return (
    <>
      {/*<button*/}
      {/*  onClick={exportPDF}*/}
      {/*  className="bg-primary text-white p-2 rounded mb-3"*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</button>*/}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "ID", key: "id" },
                { label: "Transaction Id", key: "transaction_id" },
                { label: "Service Type", key: "payable_type" },
                { label: "User Name", key: "user_name" },
                { label: "Price", key: "price" },
                { label: "Balance Before", key: "balance_before" },
                { label: "Balance After", key: "balance_after" },
                { label: "Payment Method", key: "gateway" },
                { label: "Created At", key: "created_at" },
                { label: "Paid At", key: "paid_at" },
                { label: "Status", key: "status" },
                { label: "Action", key: "action" },
              ].map((column) => (
                <TableCell
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                  key={column.label}
                  onClick={
                    column.key ? () => handleSort(column.key) : undefined
                  }
                  style={{ cursor: column.key ? "pointer" : "default" }}
                >
                  {column.label}
                  {column.key &&
                    (orderBy === column.key ? (
                      order === "asc" ? (
                        <span> ▲</span>
                      ) : (
                        <span> ▼</span>
                      )
                    ) : (
                      ""
                    ))}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.request_id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{item?.id}</TableCell>
                <TableCell align="center">{item?.transaction_id}</TableCell>
                <TableCell align="center">
                  {item?.payable_type === "App\\Models\\DomainRequest" ? 'Smm Domain' : item?.payable_type === "App\\Models\\Request" ?`Our service : ${item?.payable?.our_service}`:
                      item?.amount > 0 ? 'Add Balance' : 'Balance Deduction'
                       || <IoMdClose style={{ color: "red" }}  />}
                </TableCell>
                <TableCell align="center">
                  {item?.payable?.user_name || item?.payable?.name}
                </TableCell>
                <TableCell align="center">{item?.amount}{item?.currency}</TableCell>
                <TableCell align="center">{item?.balance_before ?? '--'}{item?.currency}</TableCell>
                <TableCell align="center">{item?.balance_after ?? '--'}{item?.currency}</TableCell>
                <TableCell align="center">{item?.gateway}</TableCell>
                <TableCell align="center">{item?.created_at}</TableCell>
                <TableCell align="center">{item?.paid_at}</TableCell>
                <TableCell align="center">{item?.status}</TableCell>
                <TableCell align="center">
                  <Link
                    to={`/Orders/${item?.uuid}`}
                    color="inherit"
                    underline="none"
                  >
                    <FaEye className="text-[#6c757d]" />
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
